import React, { type ReactNode, type PointerEvent } from 'react';
import Link from '@atlassian/jira-common-analytics-v2-wrapped-components/src/link';
import type { AnalyticsEvent } from '@atlassian/jira-common-analytics-v2-wrapped-components/src/types';

import { Container } from '../text-cell/styled';

type Props = {
	caption: ReactNode;
	href: string;
	onClick: (event: PointerEvent, analyticsEvent: AnalyticsEvent) => void;
};

export default function LinkCell({ caption, href, onClick, ...props }: Props) {
	return (
		<Container {...props}>
			{href ? (
				<Link href={href} onClick={onClick}>
					{caption}
				</Link>
			) : (
				caption
			)}
		</Container>
	);
}
